export default String.raw`
$(document).ready(function() {
    cart.init();
});

const cart = {
    collectionPointType: $('.delivery-form-js [data-type]').data('type') || window.collectionPointType || 0,

    init: function() {
        this.events();
        app.formLabelAnimationOnLoadPage();
        window.initRecommendedSlider();
    },

    toggleCartType: async function() {
        const trigger = this;
        let inquiry = false;
        if(trigger.classList.contains('change-into-cart-js')){
            inquiry = false;
            if(document.getElementsByClassName('last-inquiry-js').length > 0){
                window.app.setCookie('lastCartId', window.app.getCookie('activeInquiryId'));
                window.app.setCookie('activeInquiryId', -1);
            }
        } else {
            inquiry = true;
            if(document.getElementsByClassName('last-cart-js').length > 0){
                window.app.setCookie('activeInquiryId', window.app.getCookie('lastCartId'));
                window.app.setCookie('lastCartId', -1);
            }
            const currentStep = trigger.dataset.orderStep;
            if (currentStep == 'Third') {
                const changeStepData = {
                    __action: 'Order/StepPrev',
                    __collection: 'cart.OrderStep'
                };
                window.app.setCookie('cartAuthenticateStep', 'false');
                let changeStepResult = await js.post(changeStepData);
                let whileIteration = 0;
                while(changeStepResult.collection && changeStepResult.collection != "Start" && whileIteration < 4) {
                    changeStepResult = await js.post(changeStepData);
                    whileIteration++;
                }
            }
        }
        const message = trigger.dataset.message;
        const result = await js.post({__action: 'Inquiry/Set', inquiry: inquiry, __collection: 'cart.Products'});
        const products = result.collection;
        app.temporaryPopupMessage(null, message);
        setTimeout(() => {
            if (document.getElementsByClassName('toggle-cart-type-succeed-js').length > 0) {
                document.getElementsByClassName('toggle-cart-type-succeed-js')[0].remove();
            }
            if(trigger.classList.contains('change-into-cart-js')){
                const productsForDataLayer = [];
                const productsForGA4DataLayer = [];
                let totalValue = 0;
                for(const product of products){
                    let productPrice = Number(product.Price);
                    if (__Enterprise == 'true' && product.TotalPrice !== undefined) {
                        productPrice = Number(product.TotalPrice);
                    }
                    const productDL = { 
                        id: product.Id.toString(), 
                        name: product.NameNoHtml.trim(), 
                        price: productPrice, 
                        quantity: Number(product.Quantity)
                    };
                    const productGA4DL = { 
                        item_id: product.Id.toString(), 
                        item_name: product.NameNoHtml.trim(), 
                        price: productPrice, 
                        quantity: Number(product.Quantity)
                    };
                    productsForDataLayer.push(productDL);
                    productsForGA4DataLayer.push(productGA4DL);
                    totalValue = totalValue + (productPrice * Number(product.Quantity));
                } 
                const dataLayerProds = {
                    "products": productsForDataLayer
                };
                window.dataLayer.push({
                    "event": "addToCart",
                    "ecommerce": {
                        "currencyCode": __currCode,
                        "add": dataLayerProds
                    }
                });
                if(typeof gtag != 'undefined'){
                    gtag("event", "add_to_cart", {
                        currency: __currCode,
                        value: totalValue,
                        items: productsForGA4DataLayer
                    });
                }
                window.location.href =  window.location.href.split("?")[0];
                return;
            }
            window.location.href =  window.location.href + '?add-inquiry=true';
        }, 1000)
    },

    openDeleteCartConfirmationPopup: function() {
        const popup = document.getElementsByClassName('delete-cart-confirmation-js')[0];
        popup.classList.remove('hidden-js');
        const $popup = $(popup);
        const closeFunction = () => {
            $popup.find('.cart-popup-closer-js').click();
        }
        app.setLockFocus($popup, closeFunction, $(document.activeElement));
    },

    popupCloser: function(e) {
        if ($(e.currentTarget).hasClass('cart-popup-js')) {
            $(e.currentTarget).addClass('hidden-js');
            return;
        }
        $(e.currentTarget).parents('.cart-popup-js').addClass('hidden-js');
         app.offLockFocus();
    },

    payWithPoints: async(template, action) => {
        const result = await $.post('', {
            __csrf: __CSRF,
            __action: action,
            __template: template,
            include: 1,
        });
        if (result.action.Result) {
            app.reload();
        }
    },

    // Recalculate cart.
	recalculateCart: async (template, callback, callbackObj) => {
		document.getElementsByClassName('during-ajax-modal-js')[0].classList.remove('hidden-js');
        let message = "";
		if(document.querySelector('[name="changes-info"]')){
			message = document.querySelector('[name="changes-info"]').value;
		}
		const data = {
			__action: 'Cart/Recalculate'
		};
        if(template != undefined){
            data.__template = 'elements/cart/cart-1.html|'+template;
        } else {
            data.__template = 'elements/cart/cart-1.html';
        }
		const result = await js.post(data);
		if(template != undefined){
			document.getElementsByClassName('order-template-js')[0].outerHTML = result.template[0];
			document.getElementsByClassName('client-area-js')[0].innerHTML = result.template[1];
			changeHeaderCart();
		} else {
			document.getElementsByClassName('order-template-js')[0].outerHTML = result.template;
		}
		window.initRecommendedSlider();
		$('body').animate({
			scrollTop: 0
		}, 300);
		if(document.querySelector('[name="changes-info"]')){
            app.temporaryPopupMessage($('.steps-js'), message);
		}
		if(callback != undefined){
			callback(callbackObj, result.action.Result);
		}
		const duringAjaxModals = document.getElementsByClassName('during-ajax-modal-js');
        for (const duringAjaxModal of duringAjaxModals) {
            duringAjaxModal.classList.add('hidden-js');
        }
	},

    setPageInCart: function(params) {
        if($('.routing-js').index() != -1){
            routerSetPage(params.choosenPage);
        }
        $('.cart-products-container-js').attr('data-include', params.choosenPage);
        $('.order-template-js').attr('data-include', params.choosenPage);
    },

    paginationInCart: function(e, choosenPage) {
        if($('.cart-products-container-js').index() != -1){
            if(choosenPage == undefined){
                choosenPage = Number($(e.currentTarget).data('page'));
            }
            $('.cart-products-container-js').data('include', choosenPage);
            $('.order-template-js').data('include', choosenPage);
            $('.cart-products-container-js .during-ajax-modal-js').removeClass('hidden-js');
        }
        window.app.replaceTemplate(e, undefined, cart.setPageInCart, {e: e, choosenPage: choosenPage});
    },

    changeCartStep: async function(e) {
        const cartContainer = $(e.currentTarget).parents('.order-template-js');
        const data = {__template: cartContainer.data('template')};
        const nextStep = $(e.currentTarget).data('set');
        let reloadCart = false;
        const currentStep = $(e.currentTarget).data('step');
        if (currentStep == 'First') {
            reloadCart = true;
            if (nextStep == 'Second') {
                window.app.setCookie('cartAuthenticateStep', 'true');
            } else {
                data['__action'] = 'Order/StepNext';
            }
        } else if (currentStep == 'Second') {
            window.app.setCookie('cartAuthenticateStep', 'false');
            if (nextStep == 'Third') {
                data['__action'] = 'Order/StepNext';
                data['__collection'] = 'page.GtmDL|page.Ga4DL';
            } else {
                reloadCart = true;
            }
        } else if (currentStep == 'Third') {
            data['__action'] = 'Order/StepPrev';
            data['__collection'] = 'cart.OrderStep'
            if (nextStep == 'Second') {
                window.app.setCookie('cartAuthenticateStep', 'true');
            } else {
                reloadCart = true;
            }
        }
        let result = await js.post(data);
        let whileIteration = 0;
        while(currentStep == 'Third' && result.collection && result.collection != "Start" && whileIteration < 4) {
            result = await js.post(data);
            whileIteration++;
        }
        if (reloadCart) {
            app.reload();
            return;
        }
        if (result.template) {
            cartContainer.replaceWith(result.template);
            app.formLabelAnimationOnLoadPage();
        }
    },

    toggleInvoiceOptionInOrder: function() {
        const template = $(this).data('template');
        const include = $(this).data('include');
        const container = $(this).data('container');
        cart.invoiceChange($(this));
        $.get('', {__template: template, __include: '"'+include+'"'}, function (result) {
            if (result && result.template) {
                $(container).html(result.template);
                app.formLabelAnimationOnLoadPage();
            }
        });
    },

    changeBuyerForm: function(e) {
        const container = $(e.currentTarget).parents('.delivery-section-container-js');
        let buyerToSet = false;
        if ($(e.currentTarget).is(":checked")) {
            buyerToSet = true;
        }
        $.post('', {
            __csrf: __CSRF,
            __action: 'Order/BuyerChange',
            buyer: buyerToSet,
            __template: 'partials/cart/delivery-partials/delivery-section.html',
            __include: '"invoiceAddress"'
        }, function(result) {
            if (result && result.template) {
                $(container).html(result.template);
                if (buyerToSet) {
                    const $retailForm = $('.buyer-data-change-form-js')
                        .parent()
                        .parent()
                        .find('.retail-form-js').eq(1);
                    $retailForm.find('input').not('[type="hidden"]').not('[name="countryCode"]').not(':disabled').val('');
                }
                app.formLabelAnimationOnLoadPage();
            }
        });
    },

    editCustomerAddress: function(e) {
        const addressId = $(e.currentTarget).data('id');
        const addressDefault = $(e.currentTarget).data('default');
        let include = 'customerAddress';
        if (addressId) {
            include = include + '=' + addressId;
        }
        if (addressDefault) {
            include = include + '|default=' + addressDefault;
        }
        const editBtn = $(e.currentTarget);
        $.get('', {__template: 'partials/cart/delivery-partials/address-form.html', __include: '"'+include+'"'}, function (result) {
            if (result && result.template) {
                const popup = editBtn.parents('.delivery-section-container-js').find('.addresses-list-js .cart-customer-address-popup-js');
                const popupContent = popup.find('.cart-customer-address-popup-content-js')
                if (popupContent.length > 0) {
                    popupContent.html(result.template);
                }
                popup.find('.cart-edit-customer-address-edit-js').addClass('hidden-js');
                popup.find('.cart-edit-customer-address-new-js').addClass('hidden-js');
                if (addressId) {
                    popup.find('.cart-edit-customer-address-edit-js').removeClass('hidden-js');
                } else {
                    popup.find('.cart-edit-customer-address-new-js').removeClass('hidden-js');
                }
                popup.removeClass('hidden-js');
                app.formLabelAnimationOnLoadPage();

                const closeFunction = () => {
                    popup.find('.cart-popup-closer-js').click();
                }

                app.setLockFocus(popup, closeFunction, $(document.activeElement));
            }
        });
    },
    invoiceChange: function (invoiceInput) {
        const name = invoiceInput.attr('name')
        if(name === 'invoice' ){
            const invoiceValue = invoiceInput.val();
            $.post('', {__csrf: __CSRF, __action: 'Order/InvoiceChange', invoice: invoiceValue});
        }
    },
    //confirm addres and replace address template
    //addressType: 0 - delivery, 1 - invoice and buyer, 2 - customer
    //returns promise when address valid or null if invlaid
    confirmAddress: async function (e, templateUrl, callback) {
        const container = $(e.currentTarget).parents('.delivery-section-container-js');
        const addressType = $(e.currentTarget).data('address-type');
        cart.collectionPointType = $('.delivery-form-js [data-type]').data('type') || window.collectionPointType || 0;
        const isValid = window.app.validationBeforePost(e) == '';
        

        if (!isValid) {
            return;
        }
        let form = $(e.currentTarget).parents('.form-js');
        let data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            
        let buyerForm = [];
        let dataBuyer = [];
        
        const buyerDataCheck = form.find('.buyer-data-change-form-js');

        if (addressType === 0) {
            window.tempDAzip = document.querySelector('.delivery-address-container-js [name=zipCode]').value;
        } else if (addressType === 1) {
            if (buyerDataCheck.length > 0 && buyerDataCheck.is(':checked')) {
                buyerForm = form.find('.buyer-address-container-js');
                dataBuyer = buyerForm.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
                form = form.find('.invoice-address-container-js');
                data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            }
        }

        data.push({ name: '__collection', value: 'cart.OrderStep'});

        if (templateUrl) {
            data.push({ name: '__template', value: templateUrl });
        }

        if ($(e.currentTarget).data('next-step') != '') {
            data.push({ name: '__include', value: "'" + $(e.currentTarget).data('next-step') + "'" });
        }

        data.push({ name: '__csrf', value: __CSRF });
        dataBuyer.push({ name: '__csrf', value: __CSRF });

        const confirmResponseFunc = function (res) {
            if (res.action.Result) {
                if (res.collection == 'Start') {
                    app.reload();
                }
                if (res.template) {
                    container.html(res.template);
                    app.formLabelAnimationOnLoadPage();
                }
                let addressFilled = false;
                if (addressType == 0) {
                    if ($('.address-template-container-js.delivery-address-container-js').find('[name="email"]').length == 0) {
                        addressFilled = true;
                    }
                    if(document.getElementsByClassName('check-deligoo-when-enter-cart-js').length > 0){
                        document.querySelector('.check-deligoo-availability-form-js [name=zipCode]').value = window.tempDAzip;
                        document.getElementsByClassName('check-deligoo-when-enter-cart-js')[0].click();
                    }
                } else if (addressType == 1) {
                    if ($('.address-template-container-js.invoice-address-container-js').find('[name="name"]').length == 0) {
                        addressFilled = true;
                    }
                } else if ($('.address-template-container-js.delivery-address-container-js').find('[name="name"]').length == 0) {
                    addressFilled = true;
                }
                if (!addressFilled) {
                    app.temporaryPopupMessage(null, __translations.ConfirmAll);
                }
            } else {
                form.find('input:not([type="hidden"]), select, textarea').each(function() { window.app.validation(null, $(this)) });
            }
        };

        let invoice = false;
        let selectedCountry;
        for (const dataPair of data) {
            if (dataPair.name == 'invoice' && dataPair.value == 'true') {
                invoice = true;
            }
            if (dataPair.name == 'countryCode') {
                selectedCountry = dataPair.value;
            }
        }
        if (cart.collectionPointType != 0 && cart.collectionPointType != 10 && !window.choosenCollectionPointId) {
            data.push({ name: '__include', value: "'deliveryMethods'" });
            await $.post('', data, function (res) { confirmResponseFunc(res) });
        } else {
            if (addressType == 0) {
                if (selectedCountry != form.find('input[name=countryCode]').data('country')) {
                    __pp.lists = {};
                    await $.post('', {__csrf: __CSRF, __action: 'Order/DeliveryCountryChange', countryCode: selectedCountry});
                }
                await $.post('', data, function (res) { confirmResponseFunc(res) });
            } else if (addressType == 2) {
                data.push({ name: '__include', value: "'deliveryAddressChoose'" });
                await $.post('', data, function (res) { confirmResponseFunc(res) });
            } else {
                await $.post('', {__csrf: __CSRF, __action: 'Order/InvoiceChange', invoice: invoice});
                if (buyerDataCheck.length > 0 && buyerDataCheck.is(':checked')) {
                    await $.post('', dataBuyer)
                }
                await $.post('', data, function (res) { confirmResponseFunc(res) })
            }
        }
        
        if (callback) {
            callback(isValid);
        }
        
        $('.cart-edit-view-js[data-view="invoiceAddress"]').focus();
    },

    replacePartialTemplate: function (templateContainerSelector, templateUrl, templateInclude, callback) {
        const container = $(templateContainerSelector);
        const data = { __template: templateUrl };

        if (templateInclude) {
            data['__include'] = "'"+templateInclude+"'";
        }

        $.get('', data).then(function (res) {
            if (container.hasClass('replace-with-js')) {
                container.replaceWith(res.template);
            } else {
                container.html(res.template);
            }
            if (callback) {
                callback();
            }
            if (templateUrl == 'partials/cart/delivery-partials/delivery-section.html') {
                
                if (container.find('input[type="radio"], input[type="text"]').length > 0) {
                    $('.cart-summary-js').addClass('cart-hide-summary');
                } else {
                    $('.cart-summary-js').removeClass('cart-hide-summary');
                }
            }
        });
    },

    deliveryAddressChange: async function(e, callback) {
        let addressContainer;
        $(e.currentTarget).parents('.addresses-list-js').find('.address-option-js').each(function() {
            if ($(this).find('input[type="radio"]').is(':checked')) {
                addressContainer = $(this);
            }
        })

        if (!addressContainer) {
            return;
        }

        const container = $(e.currentTarget).parents('.delivery-section-container-js');
        const data = {};
        const valuesByData = $(addressContainer).find('[data-name]');
        const valuesByNames = $(addressContainer).find('[name]:not([type="radio"])');

        for (const valueByData of valuesByData) {
            data[$(valueByData).data('name')] = $(valueByData).text().trim();
        }

        if (valuesByNames.length > 0) {
            data[$(valuesByNames[i]).attr('name')] = $(valuesByNames[i]).val().trim();
        }

        data['__action'] = 'Order/DeliveryAddressUpdate';
        data['__csrf'] = __CSRF;

        const countryCode = $(addressContainer).find('[data-name=countryCode]').data('country');
        if (countryCode) {
            data['countryCode'] = countryCode;
        }

        let include = null;
        if ($(e.currentTarget).data('next-step') != '') {
            include = $(e.currentTarget).data('next-step');
        }

        if (data['countryCode'] != $(addressContainer).find('[data-name=countryCode]').data('selected-country')) {
            __pp.lists = {};
            await $.post('', {__csrf: __CSRF, __action: 'Order/DeliveryCountryChange', countryCode: countryCode});
        }

        $.post('', data).then(function () {
            cart.replacePartialTemplate(container, 'partials/cart/delivery-partials/delivery-section.html', include, () => {
                app.formLabelAnimationOnLoadPage();
                $('.cart-edit-view-js[data-view="deliveryAddressChoose"]').focus();
            });
            if (callback) {
                callback(data);
            }
        });
    },

    //update delivery and payment matrix
    updateDeliveryMatrix: function(radioSelector, deliveryFormSelector, scrollToSelector, e, callback) {
        const radio = $(radioSelector);
        const id = radio.val();
        const form = $(deliveryFormSelector);
        const input = form.find('[name="id"]');

        input.val(id);

        const data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();

        if (form.find('[name="__csrf"]').length == 0) {
            data.push({ name: '__csrf', value: __CSRF });
            data.push({ name: '__collection', value: 'cart.SelectedDelivery.CollectionPointTypeId|cart.Products' });
        }

        const obj = app.getTemplate(e);

        if(obj.template != undefined ){
            data.push({name: "__template", value: obj.template});
        }
        if(obj.include != null ){
            data.push({name: "__include", value: obj.include});
        }

        $.post(obj.url, data).then(async function (res) {
            if (res.action.Result) {
                cart.collectionPointType = res.collection['cart.SelectedDelivery.CollectionPointTypeId'];
                window.collectionPointType = res.collection['cart.SelectedDelivery.CollectionPointTypeId'];
                let selectedDateResult = null;
                const selectedDate = radio.data('selected-date');
                if($(e.currentTarget).hasClass('payment-js') && selectedDate) {
                    const selectedDateData = [
                        { name: '__action', value: 'Order/DeliveryDateChange' },
                        { name: 'date', value: selectedDate}
                    ];
                    selectedDateData.push({ name: '__csrf', value: __CSRF });
                    if(obj.template != undefined ){
                        selectedDateData.push({name: "__template", value: obj.template});
                    }
                    if(obj.include != null ){
                        selectedDateData.push({name: "__include", value: obj.include});
                    }
                    if(selectedDate.includes('T')){
                        selectedDateData[1].value = selectedDateData[1].value.replace('T',' ') + ':00';
                    } else {
                        selectedDateData[1].value = selectedDateData[1].value + ' 00:00:00';
                    }
                    selectedDateResult = await $.post('', selectedDateData);
                }
                let templateToReplace = res.template;
                if (selectedDateResult && selectedDateResult.template) {
                    templateToReplace = selectedDateResult.template;
                }
                window.app.afterReplaceTemplate(e, obj, templateToReplace, null, async function () {
                    app.formLabelAnimationOnLoadPage();
                    if($(e.currentTarget).hasClass('payment-js')){
                        app.dataLayerPush('selectedPayment', e);
                        if(typeof gtag != 'undefined'){
                            const products = res.collection['cart.Products'];
                            const productsForGA4DataLayer = [];
                            let totalValue = 0;
                            for (const product of products) {
                                const productGA4DL = { item_id: product.Id.toString(), item_name: product.NameNoHtml, price: product.TotalPrice, quantity: product.Quantity };
                                productsForGA4DataLayer.push(productGA4DL);
                                totalValue = totalValue + (product.TotalPrice * product.Quantity);
                            }
                            let shippingTier = $('.cart-selected-delivery-name-js').data('name').trim();
                            if($('.change-delivery-js:not(.payment-js):checked').length > 0) {
                                shippingTier = $('.change-delivery-js:not(.payment-js):checked').data('name').trim()
                            }
                            gtag("event", "add_shipping_info", {
                                currency: __currCode,
                                value: totalValue,
                                shipping_tier: shippingTier,
                                items: productsForGA4DataLayer
                            });
                            gtag("event", "add_payment_info", {
                                currency: __currCode,
                                value: totalValue,
                                payment_type: $('.change-delivery-js.payment-js:checked').data('name').trim(),
                                items: productsForGA4DataLayer
                            });
                        }
                    }
                    window.choosenCollectionPointId = undefined;
                    if($('.map-container-in-order-js').hasClass('collection-point-selected-js') || $('.collection-point-container-in-cart-js').hasClass('collection-point-selected-js')){
                        window.choosenCollectionPointId = true;
                    }
                    $('body').trigger('deliveryChange', res.collection, res);
                    if ($(scrollToSelector).index() != -1 && cart.collectionPointType != 0) {
                        const scrollTo = $(scrollToSelector);
                        const scrollToOffsetTop = scrollTo.offset().top;

                        const scrollToOffsetBottom = scrollToOffsetTop + scrollTo.height();
                        const windowOffsetBottom = $(window).scrollTop() + $(window).height();

                        if (windowOffsetBottom < scrollToOffsetBottom) {
                            $('html, body').animate({
                                scrollTop: scrollToOffsetTop
                            }, 2000);
                        }
                    }
                    if(!$(e.currentTarget).hasClass('payment-js')){
                        if(!$('.change-delivery-js:not(.payment-js):checked').data('deligoo')){
                            window.oldSelectVal = $('.change-delivery-js:not(.payment-js):checked').val();
                        } else {
                            if($('.change-delivery-js:not(.payment-js):checked').data('daZip') == ''){
                                document.body.classList.add('modal-open');
                            } else {
                                const params = js.getFormInputs(document.getElementsByClassName('check-deligoo-availability-form-js')[0]);
                                const result = await js.post(params);
                                if(!result.action.Result){
                                    document.body.classList.add('modal-open');
                                    document.getElementsByClassName('check-deligoo-availability-popup-js')[0].classList.remove('hidden-js');
                                    document.getElementsByClassName('check-deligoo-availability-js')[0].classList.add('hidden-js');
                                    document.getElementsByClassName('deligoo-success-js')[0].classList.add('hidden-js');
                                    document.getElementsByClassName('deligoo-success-icon-js')[0].classList.add('hidden-js');
                                    document.getElementsByClassName('deligoo-error-js')[0].classList.remove('hidden-js');
                                    document.getElementsByClassName('deligoo-error-icon-js')[0].classList.remove('hidden-js');
                                    document.getElementsByClassName('close-deligoo-popup-js')[0].classList.add('deligoo-fail-js');
                                    $('.change-delivery-js:not(.payment-js):checked').val(window.oldSelectVal);
                                }
                            }
                        }
                    }
                });
            }

            if (callback) {
                callback(res.collection, res);
            }
        });
    },

    processFilesList: function(fileInput, fileList) {
        const file = fileList.pop();
        if (file) {
            const fd = new FormData();
            fd.append('__csrf',__CSRF);
            fd.append('__action','Order/AttachmentAdd');
            fd.append('__template','partials/cart/attachements.html');
            fd.append('file', file);
            $.ajax({data: fd, processData: false, contentType: false, type: 'POST',
                success: function(data){
                    fileInput.value = '';
                    if(data.action.Result){
                        $('.attachements-js').html(data.template);
                    } else {
                        if(window.AttachementsNotAdded == undefined){
                            window.AttachementsNotAdded = [];
                        }
                        const attachement = '<div style="padding-bottom: 5px"><span style="font-weight: 500">' + file.name + '</span>: ' + data.action.Message + '</div>';
                        window.AttachementsNotAdded.push(attachement);
                    }
                    cart.processFilesList(fileInput, fileList);
                }
            });
        } else {
            $('.during-ajax-modal-js').addClass('hidden-js');
            fileInput.classList.remove('prevent-double-change-js');
            if(window.AttachementsNotAdded){
                const popup = '<div class="cart__popup cart-popup-js"><div class="cart__popup-box"><div class="cart__popup-header"><div class="cart__popup-title">' +
                                '<span>' + __translations.AttachementsNotAdded + '</span></div><svg role="button" tabindex="0" aria-label="' + __translations.Close + '" ' + 'class="cart__popup-closer cart-popup-closer-js">' +
                                '<use href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-' + __iconStyle + '"></use></svg></div><div class="cart__popup-content">' +
                                window.AttachementsNotAdded.join('') + '</div></div></div>';
                $('body').append(popup);
                const infoPopup = $('.cart-popup-js');
                const closeFunction = () => {
                    infoPopup.find('.cart-popup-closer-js').click();
                }
                app.setLockFocus(infoPopup, closeFunction, $(document.activeElement));
                window.AttachementsNotAdded = undefined;
            }
        }
    },

    addAttachementInOrder: function() {
        if (document.getElementsByClassName('during-ajax-modal-js').length > 0) {
            document.getElementsByClassName('during-ajax-modal-js')[0].classList.remove('hidden-js');
        }
        const fileInput = this;
        fileInput.classList.add('prevent-double-change-js');
        const fileList = Object.values(this.files);
        cart.processFilesList(fileInput, fileList);
    },

    removeAttachementInOrder: async function(trigger) {
        await js.post({__action: 'Order/AttachmentDelete', id: trigger.dataset.id});
        const parent = js.parents(trigger, 'file-container-js');
        parent.remove();
    },

    addNote: function (e, templateUrl, errorClass, callback) {
        const container = $('.note-js');

        const form = container.find('.form-js.note-in-order-js');

        if (window.app.validationBeforePost(e) == '') {
            const data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            data.push({ name: '__csrf', value: __CSRF });
            data.push({ name: '__template', value: templateUrl });

            $.post('', data).then(function (res) {
                app.formLabelAnimationOnLoadPage();
                if (!res.action.Result) {
                    form.find('.note-error-js').remove();
                    let errorClassString = '';
                    if (errorClass) {
                        errorClassString = errorClass;
                    }
                    form.append('<div class="note-error-js' + errorClassString + '">' + res.action.Message + '</div>');
                }

                if (callback) {
                    callback();
                }
            });
        } else if (callback) {
            callback();
        }
    },

    choosePaymentChannel: async function() {
        const form = document.getElementsByClassName('delivery-form-js')[0];
        const paymentChannelElement = document.querySelector('.cart-choosePaymentChannel');
        if (paymentChannelElement) {
            paymentChannelElement.classList.add('hidden-js');
        }
        const params = js.getFormInputs(form);
        params.channel = this.value;
        await js.post(params);
        if(document.querySelector('.payment-channels-js .form-error-js')){
            document.querySelector('.payment-channels-js .form-error-js').remove();
        }
        const elements = document.getElementsByClassName('payment-channel-js');
        for(const element of elements){
            element.classList.remove('active-js');
        }
        const parent = js.parents(this, 'payment-channel-js');
        parent.classList.add('active-js');
    },

    addOrder: function (e, ajaxModalSelector) {
        const addOrderEvent = {...e};
        $('.form-error-js').remove();

        let guardian = true;

        if (ajaxModalSelector) {
            $(ajaxModalSelector).removeClass('hidden-js');
        }

        const tosInputs = $('.adding-order-form-js [name="tos"]');
        tosInputs.each(function(){
            if($(this).prop('required') && !$(this).prop('checked')){
                guardian = false;
                $(this).parent().find('.validation-required-js').removeClass('hidden-js');
            }
        });

        cart.headerAttributesFilled = true;

        if($('.header-attributes-set-form-js').index() != -1){
            const headerAttributes = $('.header-attributes-set-form-js [name="attribute"]');
            headerAttributes.each(function(){
                if($(this).prop('required') && $(this).val() == ''){
                    cart.headerAttributesFilled = false;
                    $(this).parent().find('.validation-required-js').removeClass('hidden-js');
                }
            });
        }

        if($('.isSelectedPaymentChannel').length > 0){
            const isSelectedPaymentChannel = $('.isSelectedPaymentChannel');
            const isSelectedPaymentChannelData = isSelectedPaymentChannel.data('is-selected-payment-channel');
            if(isSelectedPaymentChannelData == false){
                app.temporaryPopupMessage(null, __translations.ChoosePaymentChannel, 'warn');
                if (ajaxModalSelector) {
                    $(ajaxModalSelector).addClass('hidden-js');
                }
                return;
            }
        }

        cart.positionAttributesFilled = true;

        if($('.products-table-js').index() != -1){
            const positionAttributes = $('.products-table-js [name="attribute"]');
            positionAttributes.each(function(){
                if($(this).prop('required') && $(this).val() == ''){
                    $('.show-attributes-js').trigger('click');
                    cart.positionAttributesFilled = false;
                    $(this).parent().find('.validation-required-js').removeClass('hidden-js');
                }
            });
        }

        if (!cart.headerAttributesFilled) {
            app.temporaryPopupMessage(null, __translations.fillRequiredAttributes, 'warn');
            if(cart.positionAttributesFilled && guardian){
                if (ajaxModalSelector) {
                    $(ajaxModalSelector).addClass('hidden-js');
                }
                return;
            }
        }

        if (!cart.positionAttributesFilled) {
            app.temporaryPopupMessage(null, __translations.fillRequiredAttributes, 'warn');
            app.scrollToElement(null, '.products-table-js');
            if(guardian){
                if (ajaxModalSelector) {
                    $(ajaxModalSelector).addClass('hidden-js');
                }
                return;
            }
        }

        if (!guardian) {
            if (ajaxModalSelector) {
                $(ajaxModalSelector).addClass('hidden-js');
            }
            return;
        }

        const postAddOrderForm = function(event){
            const form = $('.adding-order-form-js');
            const isValid = window.app.validationBeforePost(event) == '';
            const container = $('.delivery-section-container-js');

            if (isValid) {
                const data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
                data.push({ name: '__csrf', value: __CSRF });
                const obj = app.getTemplate(event);
                data.push({name: "__template", value: 'cart.html'});

                $.post(obj.url, data).then(function (res) {
                    if (res.action.Result) {
                        if (res.template && res.template.indexOf('external-payment-js') != -1) {
                            window.app.setCookie('lastCartId', -1);
                            window.app.setCookie('activeInquiryId', -1);
                        }
                        window.scrollTo(0, 0);
                        const parser = new DOMParser();
                        const htmlDoc = parser.parseFromString(res.template, "text/html");
                        const newBodyContent = htmlDoc.querySelector('body');

                        if (newBodyContent) {
                            document.body.innerHTML = newBodyContent.innerHTML;
                            
                            let scripts = [];
                            const mainContent = document.body.querySelector('.main-content-js');
                            if (mainContent) {
                                scripts = mainContent.querySelectorAll('script');
                            }
                            scripts.forEach(oldScript => {
                                const newScript = document.createElement('script');
                                Array.from(oldScript.attributes).forEach(attr => {
                                    newScript.setAttribute(attr.name, attr.value);
                                });
                                newScript.textContent = oldScript.textContent;
                                oldScript.parentNode.replaceChild(newScript, oldScript);
                            });
                        } else {
                            app.reload();
                        }
                        return;
                    }
                    if(res.action.Code == 1013){
                        app.reload();
                    } else {
                        let errorsHtml = '';
                        for(const i in res.action.Validation) {
                            errorsHtml += '<p>' + res.action.Validation[i].Error + '</p>';
                        }
                        if(res.action.Code == 1020){
                            app.temporaryPopupMessage(null, '<p>' + __translations.CreditLimitStatus_2 + '</p>' + errorsHtml, 'err');
                        } else if (res.action.Code == 100) {
                            app.temporaryPopupMessage(null, __translations.OrderErrorMessage, 'err');
                        } else if (res.action.Code == 1041 && container.length) {
                            app.temporaryPopupMessage(null, '<p>' + res.action.Message + '</p>' + errorsHtml, 'err');
                            cart.replacePartialTemplate(container, 'partials/cart/delivery-partials/delivery-section.html', "invoiceAddress", () => {
                                app.formLabelAnimationOnLoadPage();
                                app.getFirstFocusableElement('.delivery-section-container-js');
                            });
                        } else {
                            app.temporaryPopupMessage(null, '<p>' + res.action.Message + '</p>' + errorsHtml, 'err');
                        }
                    }
                    if (ajaxModalSelector) {
                        $(ajaxModalSelector).each(function() {
                            $(this).addClass('hidden-js');
                        });
                    }
                });
            }
        };

        if($('.attributes-view-js').index() != -1){
            let promisesArray = null;
            let globalPromise = null;
            const products = $('.position-attributes-set-form-js');
            products.each(function(){
                const form = $(this);
                const data = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
                data.push({ name: '__csrf', value: __CSRF });
                const thisPromise = $.post('', data);
                if (promisesArray) {
                    promisesArray.push(thisPromise);
                } else {
                    promisesArray = [thisPromise];
                }
            });

            if (promisesArray) {
                globalPromise = $.when.apply($, promisesArray);

                globalPromise.then(function () {
                    if($('.header-attributes-set-form-js').index() != -1){
                        const data = $('.header-attributes-set-form-js').find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
                        data.push({ name: '__csrf', value: __CSRF });
                        $.post('', data).then(function () {
                            postAddOrderForm(addOrderEvent);
                        });
                    } else {
                        postAddOrderForm(addOrderEvent);
                    }
                });
            }
        } else if($('.header-attributes-set-form-js').index() != -1){
            const data = $('.header-attributes-set-form-js').find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
            data.push({ name: '__csrf', value: __CSRF });
            $.post('', data).then(function () {
                postAddOrderForm(addOrderEvent);
            });
        } else {
            postAddOrderForm(addOrderEvent);
        }
    },

    addCoupon: function (e) {
        const form = $(e.currentTarget).parents('.form-js');
        const emailInput = form.find('[name="email"]');
        const codeInput = form.find('[name="code"]')

        emailInput.prop('required', false);
        codeInput.prop('required', true);

        const time = 2000;
        const ifValid = window.app.validationBeforePost(e) == '';

        if (ifValid) {
            window.app.post(e, undefined, undefined, '.client-area-js', 'partials/common/header/client-area.html');
            $(document).on('ajaxSuccess', function (_e, response) {
                if (response.responseJSON && response.responseJSON.action && response.responseJSON.action.Action == 'Order/CouponAdd') {
                    if (response.responseJSON.action.Message) {
                        let messageType = null;
                        if (response.responseJSON.action.Type == 'msg') {
                            messageType = response.responseJSON.action.Type;
                        }
                        app.temporaryPopupMessage(null, response.responseJSON.action.Message, messageType);
                    }
                    app.formLabelAnimationOnLoadPage();
                    const serverValidators = codeInput.parents('.form-js').find('.message-js');
                    if (serverValidators.length > 0) {
                        serverValidators.remove();
                    }
                }
            });

            emailInput.prop('required', false);
            codeInput.prop('required', false);
        } else {
            emailInput.prop('required', false);
            codeInput.prop('required', false);

            const codeValidator = codeInput.siblings('.validation-info-js');
            codeValidator.removeClass(this.hiddingClass);

            setTimeout(function () {
                codeValidator.addClass('hidden-js');
            }, time);

            if (emailInput.attr('type') != 'hidden') {
                const emailValidator = emailInput.siblings('.validation-info-js');
                emailValidator.removeClass('hidden-js');
                setTimeout(function () {
                    emailValidator.addClass('hidden-js');
                }, time);
            }
        }
        app.getFirstFocusableElement('.cart-coupon-js');
    },

    beforeAddInquiry: function(e) {
		if(app.validationBeforePost(e) != 'error'){
			if($(e.currentTarget).hasClass('empty-inquiry-js')){
				$.post('', {__csrf: __CSRF, __action: 'Cart/Create', inquiry: true}, function(result){
					const inquiryId = result.action.Object.CartId;
					$.post('', {__csrf: __CSRF, __action: 'Cart/Change', id: inquiryId}, function(){
						cart.addInquiry(e);
					});
				});
			} else {
				cart.addInquiry(e);
			}  
		}
	},
	
	addInquiry: function(e) {
		const form = $(e.currentTarget).parents('.form-js');
		const data = form.find('input:not([disabled]):not([value="Order/NoteAdd"]), select:not([disabled]), textarea:not([disabled])').serializeArray();
		data.push({name: "__csrf", value: __CSRF});
		data.push({name: "__collection", value: 'translations.ThanksInquiry|translations.InquiryEmailSent|translations.InquiryNumber|translations.Date|translations.InquiryStatus|translations.ItemsQuantity|translations.ThxInquiryInfo|translations.ComeBack|translations.Summary' });
		$.post('', data, function(result) {
			if (result.action.Result) {
				if(typeof gtag != 'undefined' && $(e.currentTarget).data('value')){
					gtag("event", "generate_lead", {
						currency: __currCode,
						value: $(e.currentTarget).data('value')
					});
				}
				const inquiryId = result.action.Object.Id;
				const inquiryStatus = result.action.Object.StatusText;
				const inquiryDate = $('[data-date]').data('date');
				const quantity = $('[data-products-quantity]').data('products-quantity');
				const thanks = result.collection['translations.ThanksInquiry'];
				const thanksText = result.collection['translations.InquiryEmailSent'];
				const idLabel = result.collection['translations.InquiryNumber'];
				const dateLabel = result.collection['translations.Date'];
				const statusLabel = result.collection['translations.InquiryStatus'];
				const quantityLabel = result.collection['translations.ItemsQuantity'];
				const thxInfo = result.collection['translations.ThxInquiryInfo'];
				const comeBack = result.collection['translations.ComeBack'];
                const summary = result.collection['translations.Summary'];
				$('.inquiry-counter-js').remove();
                $('.order-template-js').html('<div class="cart thank-you-content">' +
                                                    '<div class="thank-you"><div class="thank-you__title">' + thanks + '</div></div>' +
                                                    '<div class="thank-you__text">' + thanksText + '</div>' +
                                                    '<div class="thank-you__column-wrapper"><div class="thank-you__column">' +
                                                    '<div class="thank-you__column-title">' + summary + '</div>' +
                                                    '<div class="thank-you__column-text">' + idLabel + ': <span>' + inquiryId + '</span></div>' +
                                                    '<div class="thank-you__column-text">' + dateLabel + ': <span>' + inquiryDate + '</span></div>' +
                                                    '<div class="thank-you__column-text">' + statusLabel + ': <span>' + inquiryStatus + '</span></div>' +
                                                    '<div class="thank-you__column-text">' + quantityLabel + ': <span>' + quantity + '</span></div></div></div>' +
                                                    '<div class="thank-you__section"><div class="thank-you__section-title">' + thxInfo + '</div>' +
                                                    '<div class="thank-you__section-title">' + comeBack + '</div></div></div>');
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
				window.app.setCookie('activeInquiryId', -1);
			} else {
				form.find('.note-error-js').remove();
				form.find('.form-js').append('<div class="note-error-js error">' + result.action.Message + '</div>');
			}
		});
	},

    cartToggleOptions: function(trigger) {
        let triggerVar = trigger;
        if(triggerVar == undefined || triggerVar.target){
            triggerVar = this;
        }
        let ct = triggerVar;
        if(!triggerVar.classList.contains('div-table-options-js')){
            const parent = js.parents(triggerVar, 'options-column-js');
            ct = parent.getElementsByClassName('div-table-options-js')[0];
        }
        ct.classList.toggle('opened-js');
        ct.querySelector('svg').classList.toggle('svg');
        ct.querySelector('svg').classList.toggle('svg');
        document.getElementsByClassName('div-table-options-list-js')[0].classList.toggle('hidden-js');
    },

    validateSelectedPaymentChannel: function() {
        const selectedPayment = $("input.payment-js:checked");

        if (selectedPayment.length === 0) {
            return true;
        }

        const everySelectedPaymentChannel = selectedPayment
            .parent()
            .parent()
            .find(".cart-delivery-item__wrapper")
            .find(".choosen-payment-channel-js");

        if (everySelectedPaymentChannel.length > 0) {
            let allHidden = true;
        
            everySelectedPaymentChannel.each(function () {
                if (!$(this).hasClass("hidden-js")) {
                    allHidden = false;
                }
            });
        
            if (allHidden) {
                app.temporaryPopupMessage(undefined, __translations.ChoosePaymentChannel, 'warn');
                return false; 
            }
        }
        return true;
    },

    events: function() {
        const recalculatePopup = $('.recalculate-js');
        const closeFunction = () => {
            recalculatePopup.find('.cart-popup-closer-js').click();
        }

        if (!recalculatePopup.hasClass('hidden-js')) {
            app.setLockFocus(recalculatePopup, closeFunction, $(document.body));
        }
        $('body').on('click', '.toggle-cart-type-js', cart.toggleCartType);

        $('body').on('click', '.open-delete-cart-confirmation-js', cart.openDeleteCartConfirmationPopup);

        $('body').on('click', '.recalculate-cart-js', async function(e) {
            if ($(e.currentTarget).hasClass('recalculate-change-country-js')) {
                const form = $(e.currentTarget).parents('.cart-popup-js');
                const countrySelect = form.find('.cart-select-value-js[name=countryCode]');
                await $.post('', {__csrf: __CSRF, __action: 'Order/DeliveryCountryChange', countryCode: countrySelect.val()});
            }
            cart.recalculateCart('partials/common/header/client-area.html', (_callbackObj, success) => {
                if (success) {
                    $('.cart-recalculate-bar-js').show(400);
                    const hideBarTimeoutId = setTimeout(() => {
                        $('.cart-recalculate-bar-js').hide(400);
                        clearTimeout(hideBarTimeoutId);
                    }, 3000);
                }
            });
        });

        $('body').on('click', '.cart-popup-closer-js', cart.popupCloser);

        $('body').on('click', '.cart-popup-js', function(e) {
            if ($(e.currentTarget).find('.cart__popup-header .cart-popup-closer-js').length < 1) {
                return;
            }
            cart.popupCloser(e);
        });

        $('body').on('click', '.cart-popup-js .cart__popup-box', function(e) {
            e.stopPropagation();
        });

        js.delegate(document.body, 'click', '.delete-cart-js', app.deleteCart);

        $('body').on('click', '.pagination-in-cart-js', function (e) {
            cart.paginationInCart(e);
        });

        $('body').on('click', '.cart-change-step-js', cart.changeCartStep);

        $('body').on('mouseenter', '.cart-tooltip-js', function(e) {
            $(e.currentTarget).find('.cart-tooltip-info-js').removeClass('hidden-js');
        });

        $('body').on('mouseleave', '.cart-tooltip-js', function(e) {
            $(e.currentTarget).find('.cart-tooltip-info-js').addClass('hidden-js');
        });

        $('body').on('click', '.cart-tooltip-js', function(e) {
            $(e.currentTarget).find('.cart-tooltip-info-js').toggleClass('hidden-js');
        });

        //pay in external payment step
		$('body').on('click', '.external-payment-js', function (e) {
			e.preventDefault();
			const validate = app.validationBeforePost(e);
			if (validate != 'error') {
				const form = $(e.currentTarget).parents('.form-js');
				form.submit();
			}
		});

        $('body').on('click', '.cart-select-js', function (e) {
            if ($(e.currentTarget).siblings('.cart-select-list-js').hasClass('hidden-js')) {
                $('body').find('.cart-select-list-js').each(function() {$(this).addClass('hidden-js')});
                $('body').find('.cart-select-arrow-js').each(function() {$(this).removeClass('rotate')});
            }
            $(e.currentTarget).find('.cart-select-arrow-js').toggleClass('rotate');
            $(e.currentTarget).siblings('.cart-select-list-js').toggleClass('hidden-js');
        });

        $('body').on('click', '.cart-select-list-js li', function (e) {
            const selectedItem = $(e.currentTarget);
            const inputToChange = selectedItem.parents('.cart-select-list-js').siblings('.cart-select-value-js');
            for (const selectedItemDataset of Object.keys(selectedItem.data())) {
                if (selectedItemDataset !== 'value') {
                    inputToChange.data(selectedItemDataset, selectedItem.data(selectedItemDataset));
                }
            }
            inputToChange.val(selectedItem.data('value'));
            selectedItem.parents('.cart-select-list-js').siblings('.cart-select-js').find('.cart-select-text-js').text(selectedItem.data('name'));
            selectedItem.parents('.cart-select-list-js').siblings('.cart-select-js').find('.cart-select-arrow-js').removeClass('rotate');
            selectedItem.parents('.cart-select-list-js').addClass('hidden-js');
            inputToChange.trigger('change');
        });

        $('body').on('click', '.cart-edit-view-js', function (e) {
            if ($(e.currentTarget).hasClass('cart-validate-delivery-js')) {
                if($('.delivery-date-change-form-js').index() != -1){
                    const input = $('.delivery-date-change-form-js [name=date]');
                    const lastDate = new Date(input.data('value'));
                    const valDate = new Date(input.val());
                    const minDate = new Date(input.attr('min'));
                    let regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
                    if(input.attr('type') == 'date'){
                        regex = /^\d{4}-\d{2}-\d{2}$/;
                    }
                    if(!regex.test(input.val()) || valDate < minDate){
                        input.val(input.attr('min'));
                    }
                    if (valDate != lastDate) {
                        const data = $('.delivery-date-change-form-js').find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
                        data.push({ name: '__csrf', value: __CSRF });
                        if(input.attr('type') == 'date'){
                            data[1].value = data[1].value + ' 00:00:00';
                        } else {
                            data[1].value = data[1].value.replace('T',' ') + ':00';
                        }
                        $.post('', data);
                    }

                }

                if (cart.collectionPointType != 0 && cart.collectionPointType != 10 && !window.choosenCollectionPointId) {
                    app.temporaryPopupMessage(undefined, __translations.chooseCollectionPoint, 'warn');
                    return;
                }
            }
            const container = $(this).parents('.delivery-section-container-js');
            let viewToSet = $(this).data('view');
            if (cart.collectionPointType != 0 && cart.collectionPointType != 10 && !window.choosenCollectionPointId) {
                viewToSet = 'deliveryMethods'
            }

            if(!cart.validateSelectedPaymentChannel()){
                return;
            }

            if ($(e.currentTarget).hasClass('cart-update-summary-js')) {
                const phoneInput = $('.phoneNumberContainer');
                const checkedInput = $(e.currentTarget).parent().find('input.change-delivery-js:checked').data('phone-required');
                if (phoneInput.length === 0 && checkedInput === true  ) {
                    app.temporaryPopupMessage(undefined, __translations.LackOfPhone, 'warn');
                    cart.replacePartialTemplate(container, 'partials/cart/delivery-partials/delivery-section.html', "deliveryAddress", () => {
                        app.formLabelAnimationOnLoadPage();
                        app.getFirstFocusableElement('.delivery-section-container-js');
                    });
                }
                else{
                    cart.replacePartialTemplate('.cart-summary-js', 'partials/cart/order-summary.html', 'Third', () => {
                        cart.replacePartialTemplate(container, 'partials/cart/delivery-partials/delivery-section.html', viewToSet, () => {
                            app.formLabelAnimationOnLoadPage();
                            if (e.target.dataset.view === 'paymentMethods') {
                                app.getFirstFocusableElement('.delivery-section-container-js');
                            } else {
                                $('.cart-edit-view-js[data-view="paymentMethods"]').focus();
                            }
                        });
                    });
                }
            } else {
                cart.replacePartialTemplate(container, 'partials/cart/delivery-partials/delivery-section.html', viewToSet, () => {
                    app.formLabelAnimationOnLoadPage();
                    app.getFirstFocusableElement('.delivery-section-container-js');
                    if (cart.collectionPointType != 0 && cart.collectionPointType != 10 && !window.choosenCollectionPointId) {
                        app.temporaryPopupMessage(undefined, __translations.chooseCollectionPoint, 'warn');
                    return;
                }
                });
            }
        });

        js.delegate(document.body, 'change', '.cart-invoice-radio-change-js', cart.toggleInvoiceOptionInOrder);

        $('body').on('click', '.buyer-data-change-form-js', cart.changeBuyerForm);

        $('body').on('click', '.cart-edit-customer-address-js', cart.editCustomerAddress);

        //confirm address
        $('body').on('click', '.cart-confirm-address-js', function (e) {
            e.preventDefault();
            cart.confirmAddress(e, 'partials/cart/delivery-partials/delivery-section.html');
        });

        //change delivery address from list
        $('body').on('click', '.confirm-change-address-js', function (e) {
            cart.deliveryAddressChange(e, function (data) {
                $('.delivery-address-container-js [name=zipCode]').val(data.zipCode);
            });
        });

        //save first non-deligoo delivery
        $('.change-delivery-js:not(.payment-js)').each(function () {
            if(!$(this).data('deligoo')){
                window.oldSelectVal = $(this).val();
                return false
            }
        });
    
        //update delivery and payment matrix
        $('body').on('change', '.change-delivery-js', async function (e) {
            if(typeof initGoogle === 'function'){
                cart.updateDeliveryMatrix(this, '.delivery-form-js', '.collection-points-js', e, initGoogle);
            } else {
                cart.updateDeliveryMatrix(this, '.delivery-form-js', '.collection-points-js', e);
            }
        });

        //redraw points after update if needed
        $('body').on('deliveryChange', function (_e, pointType) {
            if (pointType == 1) {
                $('[data-type]').data('type', pointType).attr('data-type', pointType);
                if(window.google) {
                    app.getCollectionPoints();
                }
            }
        });

        js.delegate(document.body, 'change', '.add-attachement-in-order-js:not(.prevent-double-change-js)', cart.addAttachementInOrder);

        $('body').on('click', '.remove-attachement-in-order-js', (e) => {
            cart.removeAttachementInOrder(e.currentTarget);
        });

        //add note
        $('body').on('change', '.add-note-js', function (e) {
            e.preventDefault();
            cart.addNote(e, 'partials/cart/note-partials/note-form.html');
        });

        js.delegate(document.body, 'change', '.payment-channel-js [name=channel]', cart.choosePaymentChannel);

        //make order
        $('body').on('click', '.add-order-js', async function (e) {
            e.preventDefault();
            cart.addOrder(e, '.during-ajax-modal-js');
        });

        $('body').on('change', '.cart-show-coupon-js', function (e) {
            $(e.currentTarget).parents('.cart-coupon-js').find('.cart-coupon-box-js').toggle(500);
        });

        $('body').on('change', '.cart-show-points-js', function (e) {
            $(e.currentTarget).parents('.cart-points-js').find('.cart-loyalty-box-js').slideToggle(500);
        });

        $('body').on('click', '.cart-pay-with-points-js', function() {
            cart.payWithPoints('elements/cart/cart-1.html', 'Order/PointsUse');
        });

        $('body').on('click', '.cancel-pay-with-points-js', function() {
            cart.payWithPoints('elements/cart/cart-1.html', 'Order/Recalculate');
        });

        //add coupon
        $('body').on('click', '.add-coupon-js', function (e) {
            e.stopPropagation();
            cart.addCoupon(e);
        });

        $('body').on('click', '.add-inquiry-js', function (e) {
			cart.beforeAddInquiry(e);
		});

        $('body').on('click', '.recommended-product-link-in-cart-js', function (e) {
            if (window.innerWidth <= 1279) {
                e.preventDefault();
            }
        });

        $('body').on('click', '.add-to-cart-button-js', function() {
            const loadingModal = $('.order-template-js .during-ajax-modal-js')[0];
            $(loadingModal).removeClass('hidden-js'); 
        });

        $('body').on('click', '.cart-consents-js .tos-container-js [name=channelKey]', function(e) {
            if ($(e.currentTarget).is(':checked')) {
                $(e.currentTarget).parents(('.tos-container-js')).find('[name=tos]').prop('checked', true);   
            }
            let disableConsent = true;
            $(e.currentTarget).parents(('.tos-container-js')).find('[name=channelKey]').each(function() {
                if ($(this).is(':checked')) {
                    disableConsent = false;
                }
            });
            if (disableConsent) {
                $(e.currentTarget).parents(('.tos-container-js')).find('[name=tos]').prop('checked', false);
            }
        });

        js.delegate(document.body, 'click', '.div-table-options-js, .order-template-js .roll-out-js, .order-template-js .roll-up-js', this.cartToggleOptions);

        $('body').on('change', '#company', function(e) {
            if (__userAuthenticated == 'false' && $(e.currentTarget).prop('checked')) {
                app.setCookie('notAuthUserType', 'company', 30);
            }
        });

        $('body').on('change', '#company-only', function(e) {
            if (__userAuthenticated == 'false' && $(e.currentTarget).prop('checked')) {
                app.setCookie('notAuthUserType', 'private', 30);
            }
        });
    }
}

window.initRecommendedSlider = function() {
    if ($('body').find('.cart-recommended-products-list-js').length > 0) {
        const recommendedSliderInCart = new Swiper(".cart-recommended-products-list-js", {
            navigation: {
                nextEl: '.cart-recommendations-item__slider-next',
                prevEl: '.cart-recommendations-item__slider-prev',
            },
            centerInsufficientSlides: true,
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            breakpoints: {
                540: {
                    slidesPerView: 1.5,
                    slidesOffsetBefore: 32,
                    slidesOffsetAfter: 32
                },
                769: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    slidesOffsetBefore: 32,
                    slidesOffsetAfter: 32
                },
                1440: {
                    slidesPerView: 4.5,
                    spaceBetween: 36,
                    slidesOffsetBefore: 130,
                    slidesOffsetAfter: 130
                }
            }
        });
    }
};
`